import { reducer as categoriesReducer } from './categories.slice';

export default categoriesReducer;
